// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Footer_copyright__2dKwD","terms":"Footer_terms__2RjN0","landSwitcher":"Footer_landSwitcher__3Z8mr","footer":"Footer_footer__2A8uc"};